import React from 'react';
import WarmShell from './components/layout/WarmShell';
import Home from './pages/Home';

import AboutTarot from './pages/AboutTarot';
import Services from './pages/Services';
import AboutChakras from './pages/AboutChakras';
import DailyCard from './pages/DailyCard';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <WarmShell>
              <Home />
            </WarmShell>
          }
        />
        <Route
          path="/services"
          element={
            <WarmShell>
              <Services />
            </WarmShell>
          }
        />
        <Route
          path="/about-tarot"
          element={
            <WarmShell>
              <AboutTarot />
            </WarmShell>
          }
        />

        <Route
          path="/about-chakras"
          element={
            <WarmShell>
              <AboutChakras />
            </WarmShell>
          }
        />
        <Route
          path="/daily-card"
          element={
            <WarmShell>
              <DailyCard />
            </WarmShell>
          }
        />
        <Route path="/wisdom" element={<Navigate to="/about-tarot" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;